const tracky = require('src/frontend/helper/general/m_trackEvent');

export function checkPageTranslation(node) {
  const isTranslated =
    node.classList.contains('translated-ltr') ||
    node.classList.contains('translated-rtl');

  if (isTranslated) {
    tracky('google-translated', { data: { lang: node.lang } });
  }
  return isTranslated;
}

export default function trackGoogleTranslate() {
  const htmlRootNode = document.documentElement;

  if (!checkPageTranslation(htmlRootNode)) {
    const subscriber = (mutationsList, observer) => {
      mutationsList.forEach(mutation => {
        if (checkPageTranslation(mutation.target)) {
          observer.disconnect();
        }
      });
    };

    const observer = new MutationObserver(subscriber);

    observer.observe(htmlRootNode, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }
}
